
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {instrumentApi} from "@/api/instrument";
    import {deptApi, dictApi, fileApi, manufactoryApi, mechanismApi, userApi} from "@/api/organization";
    import axios from 'axios'
    import {inspectionOrderApi} from "@/api/inspection";
    import {auditApi} from "@/api/audit";
    import tempSave from "@/components/TempSave.vue";
    import reasons from '@/components/Reasons.vue'
    import MeasuringRange from "@/components/MeasuringRange.vue";
    import baseUrl, {imageUrl, uploadPage} from "@/constants";
    import UploadInstrumentImg from "@/components/UploadInstrumentImg.vue";
    const {CodeToText, regionData} =require("@/js/region/region");
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    import guid from "@/common/guid";
    import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
    import {rulesApi} from "@/api/rules";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import SelectMechanism from "@/components/SelectMechanism.vue";
    import InstrSurveyRange from "@/components/InstrSurveyRange.vue";
    import SettingInstrData from "@/components/SettingInstrData.vue";
    @Component({
        name: "instrumentDetail",
        components: {
          SettingInstrData,
          InstrSurveyRange,
          MeasuringRange,
          TableShowRangeHead,reasons,tempSave, ckeditor4, ElImageViewer, TableShowRangeBody, SelectMechanism, UploadInstrumentImg}
    })
    export default class Home extends Vue {
        title = "器具信息";
        pageType = "0";  //0添加  1编辑  2查看 4标准器 5批量导入
        id = "0";   //器具id
        result = "";  //1通过 2不通过 3查看
        heChaQiJuRight = false; //核查器具权限
        submitForm = ""; //1为检定单位从器具进入
        acceptanceOrderId = ""; // 受理不受理传参时使用的订单id
        checkResult = "";  // 检定状态
        acceptanceOrderfailDialog = false;  //不通过原因
        auditResult = "";  //机关用户，备案进入时的状态
        orderInstrumentsId = "";  //器具订单id
        orderApplyId = ""; //受理传参用
        setDialog = false;  //制造单位组件
        CodeToText = CodeToText
        regionData = regionData
        form = {
            /**
             * '强制检定计量器具名称'
             */
            name: "",
            /**
             * 强检对象特征代码
             */
            categoryCode: "",
            /**
             * 强检对象特征名称
             */
            categoryName: "",
            /**
             * 强检测量对象代码
             */
            classCode: "",
            /**
             * 强检测量对象名称
             */
            className: "",
            /**
             * 专业大类代码
             */
            majorCode: "",
            /**
             * 专业大类名称
             */
            majorName: "",
            /**
             * 器具生产属地类别代码
             */
            addrCode: "",
            /**
             * 器具生产属地类别名称
             */
            addrName: "",
            /**
             * '强检计量器具类型代码'
             */
            typeCode: '',
            /**
             * 强检计量器具类型名称
             */
            typeName: "",
            /**
             * 制造厂商Id
             */
            manufactoryId: "",
            manufactoryNameId: "",
            /**
             * 制造厂商名称
             */
            manufactoryName: "",
            /**
             * 型号/规格
             */
            modelSpecific: "",
            /**
             * 型批证号
             */
            licence: "",
            /**
             * 出厂编号
             */
            serialNumber: "",
            /**
             * 生产日期
             */
            productionTime: "",
            /**
             * 内部编号
             */
            internalNumber: "",
            /**
             * 使用单位
             */
            useUnit: "",
            /**
             * 器具使用地行政区划代码
             */
            useAddrCode: "",
            useAddrCodeArr: [],
            /**
             * 器具使用地行政区划代码
             */
            useOrgAddrCode: "",
            useOrgAddrCodeArr: [],
            /**
             * 器具使用地行政区划名称
             */
            useAddrName: "",
            /**
             * 安装/使用地点
             */
            setupPlace: "",
            /**
             * 工作计量器具用途代码
             */
            purposeCode: "",
            /**
             * 工作计量器具用途名称
             */
            purposeName: "",
            /**
             * 购置日期
             */
            purchaseDate: "",
            /**
             * 器具状态
             */
            states: "",
            /**
             * 使用部门
             */
            useDept: "",
            /**
             * 责任人员
             */
            custodian: "",
            /**
             * 测量范围
             */
            paramList: [],
            /**
             * 量程
             */
            range: "",
            /**
             * 新测量范围
             */
            measuringRangeV2: "",
            /**
             * 示值误差
             */
            indicationError: "",
            /**
             * 分度值
             */
            divisionValue: "",
            /**
             * 准确度
             */
            accuracyLevel: "",
            /**
             * 分辨率
             */
            resolvingPower: "",
            /**
             * 主体材料
             */
            mainMaterial: "",
            /**
             * 外观
             */
            appearance: "",

            imgPath: "",
            /**
             * 目录一
             */
            catalogueOne: null,
            /**
             * 目录一名称
             */
            catalogueOneName: null,
            /**
             * 目录二
             */
            catalogueTwo: null,
            /**
             * 目录二名称
             */
            catalogueTwoName: null,
            excel: "",
            /**
             * 检定数值
             */
            data:"",
        } as any
        validateChange = (rule:any, value:any, callback:any) => {
            if (value === '') {
                callback(new Error('请输入出厂编号'));
            } else if (!this.getChangeSerialNumber()) {
                callback(new Error('必须修改出厂编号'));
            } else {
                callback();
            }
        };
        validateChange2 = (rule:any, value:any, callback:any) => {
            if (value === '') {
                callback(new Error('请输入内部编号'));
            } else if (!this.getChangeInternalNumber()) {
                callback(new Error('必须修改内部编号'));
            } else {
                callback();
            }
        };
        imgPathValidator = (rule: any, value: any, callback: any) => {
            let uploadImg = this.$refs['uploadImg'] as any;
            if(this.pageType !== '5' ){
              callback();
              return;
            }
            if(uploadImg && !uploadImg.onDataValidate()){
                callback();
            }else{
                callback();
            }
        }
        rules = {
            name: [{ required: true, message: '请输入器具名称', trigger: 'blur' }],
            categoryCode: [{ required: true, message: '请选择器具项别', trigger: 'change' }],
            classCode: [{ required: true, message: '请选择器具种别', trigger: 'change' }],
            majorCode: [{ required: true, message: '请选择专业类别', trigger: 'change' }],
            addrCode: [{ required: true, message: '请选择器具类别', trigger: 'change' }],
            typeCode: [{ required: true, message: '请选择器具类型', trigger: 'change' }],
            manufactoryNameId: [{ required: true, message: '请选择制造单位', trigger: 'change' }],
            modelSpecific: [{ required: true, message: '请输入规格型号', trigger: 'blur' }],
            licence: [{ required: true, message: '请输入型批证号', trigger: 'blur' }],
            serialNumber: [{ required: true, message: '请输入出厂编号', trigger: 'blur' },{ validator: this.validateChange, trigger: 'blur' }],
            internalNumber: [{ required: true, message: '请输入内部编号', trigger: 'blur' },{ validator: this.validateChange2, trigger: 'blur' }],
            useUnit: [{ required: true, message: '请输入使用单位', trigger: 'blur' }],
            useAddrCode: [{ required: true, message: '请选择单位区域', trigger: 'change' }],
            useOrgAddrCode: [{ required: true, message: '请选择使用区域', trigger: 'change' }],
            purposeCode: [{ required: true, message: '请选择器具用途', trigger: 'change' }],
            states: [{ required: true, message: '请选择器具状态', trigger: 'change' }],
            paramList: [{ required: true, message: '请填写测量范围', trigger: 'blur' }],
            measuringRangeV2: [{ required: true, message: '请输入测量范围', trigger: 'blur' }],
            excel: [{ required: true, message: '请上传导入excel', trigger: 'change' }],
            imgPath: [{  required: true, validator: this.imgPathValidator, trigger: 'change' }]
        }
        form2 = {
            certificationNumber: "",   //证书编号
            certificateType: "",       //证书类型
            inspectionDate: "",        //检定日期
            expireDate: "",            //有效期
            checkCocn: "",             //检定结论
            checkResult: 1,           //检定结果
            resultText: "",            //检定结果
            basedRuleId: "",           //检定依据
            basedRuleName: "",         //检定依据名称
            reason: "",                //不合格原因
            checkPersonId: "",         //检定员id
            checkPersonName: "",       //检定员姓名
            checkPersonCardCode: "",   //检定员身份证号
            reApproverId: "",          //核验员id
            reApproverName: "",        //核验员姓名
            reApproverCardCode: "",    //核验员身份证号
            approverId: "",            //批准人id
            approverName: "",          //批准人名称
            approverCardCode: "",      //批准人身份证号
            enclosure: "",  //影印件
        }
        validCheckResult = (rule: any, value: any, cb: any) => {
            if(value != '0' || value != 0) {
                cb();
            }else{
                cb(new Error('请选择检定状态'));
            }
        }
        categoryCodeList = [];  //对象特征
        classCodeList = [];     //测量对象
        addrCodeList = [];      //器具类别
        typeCodeList = [];      //器具类型
        purposeCodeList = [];   //工作器具用途
        statesList = [];        //器具状态
        oldImgList = [] as any; //旧图片
        addForm2 = false;  //是否添加form2表单

        screenHeight = document.documentElement.clientHeight; // 可见区域高度(应为body高度，可某些环境下无法获取)
        private closePage: any;
        failDialog = false;  //不通过原因

        userList = [];  //本单位人员列表
        userList2 = [];  //本单位人员列表

        useDeptList = [];  //使用部门
        useDeptList2 = [] as any;  //使用部门

        listInstrument = [] as any //器具备选列表

        props = {
            value: 'instrumentNameId',
            label: 'name',
        }
        propsDept = {
            value: 'id',
            label: 'name',
        }
        instrumentObj = null as any  //选中的器具对象
        showAllLevels = false;
        baseUrl = baseUrl
        imageUrl = imageUrl
        headers = {Authorization:""}
        fileListCheck = [] as any;
        dialogImageUrl = "";
        imagePreviewVisible = false;
        departs = [];
        userData = null as any;
        defaultProps = {
            children: 'children',
            label: 'name'
        }
        filterText = "";
        useDeptDialog = false;
        useDeptDialogForm = {
            id: "",
            name: ""
        };
        loaded = false;
        loading = false;
        changeSerialNumber = true;  //改变出厂编号
        changeInternalNumber = true; //改变内部编号

        excelFileList = [] as any;
        fullScreen = false;

        editInstrData = {
          visible: false // 检定数值弹框
        }


        mounted() {
          this.haveRight();
          this.init();
        }
        init(){
            if(this.$route.path.indexOf('external') !== -1){
                this.fullScreen = true;
            }
            this.userData = this.$store.state.AuthedUser;
            this.pageType = this.$route.params.type;
            this.id = this.$route.params.id;
            this.result = this.$route.query.result as string;
            this.auditResult = this.$route.query.auditResult as string;
            this.orderInstrumentsId = this.$route.query.orderInstrumentsId as string;
            this.orderApplyId = this.$route.query.orderApplyId as string;
            this.submitForm = this.$route.query.submitForm as string;
            this.acceptanceOrderId = this.$route.query.orderId as string;
            this.checkResult = this.$route.query.checkResult as string;
            if(this.result != undefined){
                if(this.orderInstrumentsId){
                    this.addForm2 = true;
                    this.$nextTick(()=>{
                        this.getForm2Data();
                    })
                }
            }
            //对象特征，测量对象
            //专业大类
            //类型
            //工作计量器具用途
            //状态
            //制造单位列表
            this.loading = true;
            axios.all([this.getDict(6),
                this.getDict(3),
                this.getDict(1),
                this.getDict(2),
                this.getDict(7),
                this.getUserList(),
                this.getUseDept(),
                this.getListInstrument(),
                this.listDept() //部门树],
            ]).then(axios.spread((acct,perms)=>{
                if(this.pageType != "0" && this.pageType != "4" && this.pageType != "5"){
                    this.getDetail();
                }else{
                    const userData = this.$store.state.AuthedUser;
                    this.form.useUnit = userData.organizationName;
                    const organizationRegion = userData.organizationRegion;
                    if(organizationRegion) {
                        this.form.useAddrCodeArr = organizationRegion.split(",");
                        this.form.useAddrCode = organizationRegion;
                        this.form.useOrgAddrCodeArr = organizationRegion.split(",");
                        this.form.useOrgAddrCode = organizationRegion;
                    }
                    this.loading = false;
                    this.loaded = true;
                }
            }))
        }
        get titleText(){
            if(this.auditResult == '1'){
                return '备案器具信息';
            }else if(this.result=='1'||this.result=='2'){
                return '检定器具信息';
            }else if(this.pageType=='5'){
                return '批量导入器具';
            }else{
                return '计量器具信息';
            }
        }
        getTempData(e: any){
            if(e){
                const rData = JSON.parse(e);
                this.form = Object.assign(this.form, rData);
            }
        }
        handleUpdateChange(value: any) {
            this.form.useAddrCode = value.join(",").replace(/\s+/g, "");
        }
        handleUpdateChangeOrg(value: any) {
            this.form.useOrgAddrCode = value.join(",").replace(/\s+/g, "");
        }
        //获取器具详情
        getDetail(){
            instrumentApi.getDetailById({id:this.id}).then(r=>{
                this.loading = false;
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    rData.states = String(rData.states);


                    if(rData.useDept){
                        try {
                            rData.useDept = rData.useDept.split(",").map((i:any) => i * 1);
                        } catch (e) {
                            console.log(e)
                        }
                    }

                    if(rData.oldImgPath){
                        this.oldImgList = [];
                        try {
                            const obj = JSON.parse(rData.oldImgPath);
                            if(typeof obj == 'object' && obj ){
                                for(let i = 0; i < obj.length; i++){
                                    this.oldImgList.push({ name: obj[i].name , url: imageUrl + obj[i].url})
                                }
                            }
                        } catch(e) {
                            const arr = rData.oldImgPath.split(",");
                            for(let i = 0; i < arr.length; i++){
                                this.oldImgList.push({name:"计量器具图片",url: imageUrl + arr[i]})
                            }
                        }
                    }

                    this.form = Object.assign(this.form, rData);
                    this.form.useAddrCodeArr = rData.useAddrCode ? rData.useAddrCode.split(",") : [];
                    this.form.useOrgAddrCodeArr = rData.useOrgAddrCode ? rData.useOrgAddrCode.split(",") : [];
                    this.$nextTick(()=>{
                        const arr = [];
                        arr.push(Number(rData.majorCode));
                        arr.push(Number(rData.classCode));
                        arr.push(Number(rData.categoryCode));
                        arr.push(Number(rData.instrumentNameId));
                        this.form.name = arr;
                        this.initFormInstrumentCode(arr);
                        const obj2 = this.userList.find((e:any)=>e.id == this.form.custodian);
                        if(obj2){
                            this.userList2 = [obj2];
                        }
                        const obj3 = this.useDeptList.find((e:any)=>e.id == this.form.useDept);
                        if(obj3){
                            this.useDeptList2 = [obj3];
                        }
                    })
                }
            })
        }
        //获取器具备选列表个
        getListInstrument(){
            return dictApi.listDictInstrument().then(r=>{
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTree(rData);
                    this.listInstrument = rData;
                    if(this.pageType == "0" && this.form.name){
                        //有暂存数据
                        if(this.form.name.length >= 4){
                            this.initFormInstrumentCode(this.form.name);
                        }
                    }
                }
            })
        }
        porjectTree(projectList: any){
            projectList.forEach((project: any) => {
                if(project.children.length > 0){
                    this.porjectTree(project.children);
                }else{
                    project.children = null;
                }
            })
        }
        nameChange(value: any){
            if(value.length >= 4){
                this.initFormInstrumentCode(value);
                this.form.data = "";
            }else if(value.length == 0){
                this.form.categoryCode = "";
                this.form.classCode = "";
                this.form.majorCode = "";
                this.form.data = "";
            }
        }
        initFormInstrumentCode(value: any){
            return new Promise(resolve => {
                this.showAllLevels = false;
                const obj0 = this.listInstrument.find((e:any)=>e.instrumentNameId==value[0]);
                const obj1 = obj0.children.find((e:any)=>e.instrumentNameId==value[1]);
                const obj2 = obj1.children.find((e:any)=>e.instrumentNameId==value[2]);
                const obj3 = obj2.children.find((e:any)=>e.instrumentNameId==value[3]);
                this.form.categoryCode = obj2.name;
                this.form.classCode = obj1.name;
                this.form.majorCode = obj0.name;
                this.form.categoryCode = obj2.name;
                //一级目录
                this.form.catalogueOne = obj3.catalogueOne;
                this.form.catalogueOneName = obj3.catalogueOneName;
                //二级目录
                this.form.catalogueTwo = obj3.catalogueTwo;
                this.form.catalogueTwoName = obj3.catalogueTwoName;
                this.instrumentObj = obj3;
                resolve(obj3);
            })
        }
        //获取本单位人员列表
        getUserList(){
            const userData = this.$store.state.AuthedUser;
            const params = {
                // login: 1,
                // status: 1,
                organizationId: userData.organizationId,
                size: 9999,
                current: 1,
            }
            return userApi.list(params).then(r => {
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.userList = rData.records;
                    if(this.form.custodian){
                        const obj2 = this.userList.find((e:any)=>e.id == this.form.custodian);
                        if(obj2){
                            this.userList2 = [obj2];
                        }
                    }
                }
            })
        }
        //获取使用部门列表
        getUseDept(){
            return deptApi.list().then(r => {
                if(r.data.result == 0){
                    const rData = r.data.data;
                    this.useDeptList = rData;
                    if(this.form.useDept){
                        const obj3 = this.useDeptList.find((e:any)=>e.id == this.form.useDept);
                        this.useDeptList2 = [obj3];
                    }
                }
            })
        }

        clearSelect2(){
            this.remoteMethod2("");
        }

        draftUnitQuery2 = "";
        remoteMethod2(query: any){
            if (query !== '') {
                this.userList2 = this.userList.filter((item:any) => {
                    return item.name.toLowerCase()
                        .indexOf(query.toLowerCase()) > -1;
                });
                this.draftUnitQuery2 = query;
            } else {
                this.userList2 = [];
                this.draftUnitQuery2 = "";
            }
        }

        getDict(category: number, code: string | string = ""){
            return dictApi.list({
                category: category,
                code: code
            }).then(r=>{
                if(r.data.result === 0){
                    const rData = r.data.data;
                    let firstCode = "";
                    if(rData.length > 0){
                        firstCode = rData[0].code;
                    }
                    if(category == 6 && code == ""){
                        this.categoryCodeList = rData;
                        // this.form.categoryCode = firstCode;
                        // if(rData.length > 0){
                        //     this.getDict(6,rData[0].code);
                        // }
                    }else if(category == 6 && code !== ""){
                        this.classCodeList = rData;
                        // this.form.classCode = firstCode;
                    }else if(category == 3){
                        this.addrCodeList = rData;
                        // this.form.addrCode = firstCode;
                    }else if(category == 1){
                      if(this.heChaQiJuRight){
                        rData.push({id: 1622, code: '4', name: '核查检定器具',category: 1});
                      }
                      this.typeCodeList = rData;
                        // this.form.typeCode = firstCode;
                    }else if(category == 2){
                        this.purposeCodeList = rData;
                        // this.form.purposeCode = firstCode;
                    }else if(category == 7){
                      if(this.pageType === '0'){
                        this.statesList = rData.filter((s: any) => s.code != 3);
                      }else {
                        this.statesList = rData;
                      }
                    }
                }
            })
        }
        onDataValidate(callback: any){
            let form = this.$refs.form as HTMLFormElement;
            let uploadImg = this.$refs['uploadImg'] as any;
            form.validate((valid:any) => {
                if (valid) {
                  if(this.pageType === '5' || (!uploadImg.onDataValidate())){
                    callback();
                  }
                }else{
                    this.$message.warning("未填写完整信息");
                }
            });
        }
        onSubmit() {
            this.form.excel = "";
            let excelList = this.excelFileList.map((e: any) => {
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl, "")
                }
            });
            this.form.excel = excelList.length === 0 ? "" :  JSON.stringify(excelList);
            this.onDataValidate(() => {
                let params = {
                    ...this.form
                }
                params.categoryName = this.form.categoryCode;
                params.className = this.form.classCode;
                params.majorName = this.form.majorCode;
                params.categoryCode = this.form.name[2];
                params.classCode = this.form.name[1];
                params.majorCode = this.form.name[0];
                params.instrumentNameId = this.form.name[3];
                params.strong = this.instrumentObj.strong;
                params.name = this.instrumentObj.name;
                params.dictInstrumentId = this.instrumentObj.id;
                let useAddrName = "";
                try{
                    params.useAddrCodeArr.forEach((useAddrCode: string) => {
                        useAddrName += CodeToText[useAddrCode];
                    });
                }catch(e) {
                    console.log("获取单位区域名称");
                }
                params.useAddrName = useAddrName;
                if(params.excel){
                    params.file = JSON.parse(params.excel)[0].url;
                }
                const addrCodeObj = this.addrCodeList.find((e:any)=>e.code==this.form.addrCode) as any;
                if(addrCodeObj){params.addrName = addrCodeObj.name;}

                const purposeCodeObj = this.purposeCodeList.find((e:any)=>e.code==this.form.purposeCode) as any;
                if(purposeCodeObj){params.purposeName = purposeCodeObj.name;}
                //使用部门
                if(this.form.useDept && this.form.useDept.length > 0){
                    const lastUseDeptId = this.form.useDept[this.form.useDept.length-1];
                    const useDeptObj = this.useDeptList.find((e:any)=>e.id==lastUseDeptId) as any;
                    if(useDeptObj){params.useDeptName = useDeptObj.name;}
                    params.useDept = params.useDept.join(",");
                }else{
                    params.useDept = "";
                    params.useDeptName = "";
                }
                //责任人员
                const userObj = this.userList.find((e:any)=>e.id==this.form.custodian) as any;
                if(userObj){params.custodianName = userObj.name;}
                const typeCodeObj = this.typeCodeList.find((e:any)=>e.code==params.typeCode) as any;
                if(typeCodeObj){params.typeName = typeCodeObj.name;}

                if(this.id != "0"){
                    params = Object.assign(params,{id: this.id});
                }
                this.loading = true;
                let api;
                if(this.pageType == '5'){
                    api = instrumentApi.importInstruments(params);
                }else{
                    api = instrumentApi.update(params);
                }
                api.then(r=>{
                    this.loading = false;
                    if(r.data.result === 0){
                        if(this.addForm2){
                            this.onSubmit2(r.data.data);
                        }else{
                            let $tempSave = this.$refs.tempSave as HTMLFormElement;
                            if($tempSave){
                                $tempSave.deleteUserConfig();
                            }
                            if(this.id != "0"){
                                this.$message.success("保存成功");
                                this.closePage();
                            }else{
                                this.$confirm('保存成功', '提示', {
                                    confirmButtonText: '返回列表',
                                    cancelButtonText: this.pageType=='5'?'继续导入':'继续添加',
                                    type: 'warning'
                                }).then(() => {
                                    this.closePage();
                                }).catch(() => {
                                    this.changeSerialNumber = false;
                                    this.changeInternalNumber = false;
                                });
                            }
                        }
                    }
                })
            });
        }
        getChangeSerialNumber(){
            return this.changeSerialNumber;
        }
        getChangeInternalNumber(){
            return this.changeInternalNumber;
        }
        onSubmit2(instrumentsId: number | number = 0) {
            //影印件****
            const enclosureList = this.fileListCheck.map((e:any)=>{
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl,"")
                }
            })
            this.form2.enclosure = enclosureList.length === 0 ? "" :  JSON.stringify(enclosureList);
            //影印件end****
            let form = this.$refs.form2 as HTMLFormElement;
            form.validate((valid:any) => {
                if (valid) {
                    let params: any;
                    //如果未通过  则只存结果
                    if(this.form2.checkResult == 4){
                        params = {checkResult: this.form2.checkResult, resultText: this.form2.resultText};
                    }else{
                        params = {...this.form2};
                    }
                    params.submitForm = this.submitForm;
                    if(instrumentsId != 0){
                        params = Object.assign(params, {instrumentsId: instrumentsId})
                    }else{
                        params = Object.assign(params, {orderInstrumentsId: this.orderInstrumentsId})
                    }
                    inspectionOrderApi.updateInspectionOrderInstruments(params).then(r=>{
                        if(r.data.result === 0){
                            this.$message.success("保存成功");
                            this.closePage();
                        }
                    })
                }
            });
        }
        //result 2 拒收  1接收
        onSubmit3(result: number){
            const params = {
                instrumentIds: this.id,
                orderId: this.orderInstrumentsId,
                result: result
            }
            auditApi.checkOrder(params).then(r => {
                this.$message.success("设置成功");
                this.closePage();
            })
        }
        failBtn(){
            this.failDialog = true;
        }
        orderNotPassBtn(){
            let reasons = this.$refs.reasons as HTMLFormElement;
            const reason = reasons.getText();
            if(reason == ""){
                this.$message.error("拒收原因必填");
                return
            }
            const list = [{
                instrumentId: this.id,
                reason: reason
            }]
            const params = {
                orderId: this.orderInstrumentsId,
                list: list
            }
            auditApi.orderNotPass(params).then(r => {
                this.failDialog = false;
                this.$message.success("设置成功");
                this.closePage();
            })
        }
        getForm2Data(){
            inspectionOrderApi.getInspectionOrderInstruments({id: this.orderInstrumentsId}).then(r=>{
                if(r.data.result == 0){
                    const rData = r.data.data;
                    //3 待检定
                    if(rData.checkResult.value != 3){
                        this.form2 = Object.assign(this.form2, rData);
                        this.form2.checkResult = rData.checkResult.value;

                        //影印件***********
                        if(rData.enclosure){
                            this.fileListCheck = [];
                            try {
                                var obj=JSON.parse(rData.enclosure);
                                if(typeof obj == 'object' && obj ){
                                    for(let i = 0; i < obj.length; i++){
                                        this.fileListCheck.push({name: obj[i].name ,url: imageUrl+obj[i].url})
                                    }
                                }
                            } catch(e) {
                                const arr = rData.enclosure.split(",");
                                for(let i = 0; i < arr.length; i++){
                                    this.fileListCheck.push({name:"证书文件",url: imageUrl+arr[i]})
                                }
                            }
                        }else{
                            this.fileListCheck = [];
                        }
                        //影印件end******************
                    }
                }
            })
        }
        keyword = "";
        filterMeasuringItems(keyword: string){
            this.keyword = keyword;
        }
        //测量范围************************************************

        addSurveyRanges = {
            visible: false,
            surveyRanges: [],
            params: null as any,
        }
        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }

        openAddSurveyRangesDiglog(surveyRanges: any) {
            surveyRanges = this.cloneObjectFn(surveyRanges);
            this.addSurveyRanges.surveyRanges = surveyRanges;
            this.addSurveyRanges.params = {};
            this.addSurveyRanges.visible = true;
        }

        closeAddSurveyRangesDiglog() {
            this.addSurveyRanges.visible = false;
            this.addSurveyRanges.surveyRanges = [];
            this.addSurveyRanges.params = null;
        }

        submitAddSurveyRanges(e: any) {
            let paramList = this.cloneObjectFn(e.paramList);
            this.form.paramList = paramList;
            this.closeAddSurveyRangesDiglog();
        }
        handlePictureCardPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if (fix == "pdf" || fix == "xlsx" || fix == "xls") {
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
            } else {
                this.dialogImageUrl = file.url;
                this.imagePreviewVisible = true;
            }
        }

        // 关闭查看器
        closeViewer() {
            this.imagePreviewVisible = false;
        }
        filterNode(value: any, data: any) {
            if (!value) return true;
            return data.name.indexOf(value) !== -1;
        }
        //加载部门树
        listDept(){
            //如果没有单位，无法加载部门
            if(!this.userData.organizationId) return;
            deptApi.tree(null).then((r:any)=>{
                if(r.data.result === 0){
                    const rData = r.data.data;
                    this.clearNullChildren(rData);
                    this.departs = rData;
                }
            })
        }
        //递归清除空子集
        clearNullChildren(data: any[]){
            for(const d of data){
                if(!d.children) continue;
                if(d.children.length == 0){
                    d.children = null;
                }else{
                    this.clearNullChildren(d.children);
                }
            }
        }
        //点击树的节点
        treeChange(a:any){
            this.useDeptDialogForm.id = a.id;
            this.useDeptDialogForm.name = a.name;
        }
        haveRight(){
          const right = this.$store.state.userRights;
          this.heChaQiJuRight = false;
          right.forEach((e: any) => {
            if (e.name == "核查器具") {
              this.heChaQiJuRight = true;
            }
          })
        }
        setUseDept(){
            if(this.useDeptDialogForm.id == ""){
                this.$message.error("请先选择一个部门");
                return
            }
            this.form.useDept = this.useDeptDialogForm.id;
            this.form.useDeptName = this.useDeptDialogForm.name;
            this.useDeptDialog = false;
        }
        //清空
        clearForm(){
            const options = this.$options as any;
            Object.assign(this.$data, options.data.call(this));
            this.init();
        }

        //器具类型改变
        addTypesChange(){
            this.form.purposeCode = "";
            this.form.states = "";
        }

        downBtn(){
            this.$message.error("下载档案，暂未实现");
        }
        inputBtn(){
            this.$message.error("导入检定结果，暂未实现");
        }
        @Watch("filterText")
        getFormUseDept(val: any){
            const $tree = this.$refs.tree as HTMLFormElement;
            if($tree){
                $tree.filter(val);
            }
        }

        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }
    //    导入excel
        excelSuccess(res: any, fileny: any) {
            if (res.result === 0) {
                const rData = res.data;
                this.excelFileList.push({name: "导入文件",url: imageUrl+rData})
                this.$message.success("上传成功，点击保存后生效");
            }
        }
        excelRemove(file: any, fileList: any) {
            const index = this.excelFileList.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.excelFileList.splice(index, 1);
            }
        }
        downloadBtn(){
            window.open(baseUrl + "/file/download?file=" + "/qijudaoru.xlsx" + "&name=器具导入模板.xlsx", '_blank');
        }

        //获取器具的勾选  0查看  1受理  2不受理
        instrumentCheck(type: number){
            if(type == 1){
                const params = {
                    orderInstrumentsIds: this.orderInstrumentsId,
                    checkResult: "",
                    status: 8,
                    orderId: this.acceptanceOrderId,
                    orderApplyId: this.orderApplyId
                }
                inspectionOrderApi.acceptanceOrNot(params).then(r => {
                    if (r.data.result == 0) {
                        this.$message.success("受理成功");
                        this.closePage();
                    }
                })
            }else if(type == 2){
                this.acceptanceOrderfailDialog = true;
            }
        }
        //不受理确定
        inadmissibleBtn(){
            let reasons = this.$refs.reasons as HTMLFormElement;
            const reason = reasons.getText();
            if(reason == ""){
                this.$message.error("不受理原因必填");
                return
            }
            const params = {
                orderInstrumentsIds: this.orderInstrumentsId,
                checkResult: reason,
                status: 3,
                orderId: this.acceptanceOrderId,
                orderApplyId: this.orderApplyId
            }
            inspectionOrderApi.acceptanceOrNot(params).then(r => {
                if (r.data.result == 0) {
                    this.$message.success("不受理成功");
                    this.acceptanceOrderfailDialog = false;
                    this.closePage();
                }
            })
        }
        changeManufactory(e: any) {
            this.form.manufactoryId = e.mechanismId;
            this.form.manufactoryNameId = e.mechanismNameId;
            this.form.manufactoryName = e.mechanismName;
        }
        changeUploadImg(imgPath: string){
            this.form.imgPath = imgPath;
        }
        saveInstrData(e: string){
          this.form.data = e;
        }
    }
